import Vue from 'vue';

Vue.component('banqueting-page-component', {
    data() {
        return {

        }
    },

    mounted() {
        zenscroll.setup(null, 200);
    },

    methods: {
        
    },

    beforeDestroy() {

    }
});
